import React, { Fragment, useEffect, useState } from 'react';
import { Menu, Search } from 'lucide-react';
import { useLocation } from 'react-router-dom';
import axiosInstance from '../../reactWrapper/endpoints/axios';
import MobileMenu from './MobileMenu';
import UserInfo from './UserInfo';
import { pageTitleFor, sectionFor } from './navItems';

/**
 * The sticky console header (reference: client.tsx). Contents L→R: the
 * eyebrow + page title block, search, then the user pill. The page title
 * appears twice by design — small here, large in the body via SectionHeader.
 */
export const Header = () => {
  const [showMobileMenu, setShowMobileMenu] = useState(false);
  const [scoutEnabled, setScoutEnabled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const fetchScoutState = async () => {
      try {
        const response = await axiosInstance.get('/admin/getScoutDiscount');
        if (response.data.status) {
          setScoutEnabled(response.data.data?.state === 1);
        }
      } catch (error) {
        console.error('Failed to fetch scout state:', error);
      }
    };
    fetchScoutState();
  }, []);

  return (
    <Fragment>
      <header className='sticky top-0 z-40 flex h-14 shrink-0 items-center gap-3 border-b bg-card px-4 sm:px-6'>
        <button
          type='button'
          onClick={() => setShowMobileMenu(true)}
          aria-label='Open menu'
          className='-ml-2 shrink-0 rounded-full p-2 text-brand-navy transition-colors hover:bg-surface lg:hidden'
        >
          <Menu className='h-5 w-5' />
        </button>

        <div className='min-w-0 flex-1'>
          <div className='text-[11px] uppercase tracking-wider text-muted-foreground'>
            {sectionFor(location.pathname)}
          </div>
          <h1 className='truncate text-sm font-bold text-brand-navy sm:text-base'>
            {pageTitleFor(location.pathname)}
          </h1>
        </div>

        <div className='relative hidden md:block'>
          <Search className='pointer-events-none absolute left-2.5 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground' />
          <input
            id='search'
            type='text'
            name='search'
            placeholder='Search...'
            className='h-9 w-72 rounded-lg border border-border bg-background pl-8 pr-3 text-sm focus:outline-none focus:ring-2 focus:ring-brand-orange'
          />
        </div>

        <UserInfo scoutEnabled={scoutEnabled} />
      </header>

      {showMobileMenu && (
        <MobileMenu
          showMobileMenu={showMobileMenu}
          setShowMobileMenu={setShowMobileMenu}
        />
      )}
    </Fragment>
  );
};

export default Header;
